/**
 * Generated by orval v8.9.1 🍺
 * Do not edit manually.
 * Praetoid Dashboard API
 * OpenAPI spec version: 1.0
 */
import * as zod from 'zod';

export const UpdatePraetorPolicyPlanBody = zod
	.object({
		enabled: zod.boolean().optional().describe('Whether component is enabled'),
		policy_plan_version_id: zod.string().nullish().describe('Policy plan version pin'),
		position: zod.number().optional().describe('Ordering position')
	})
	.describe('Request body for updating a policy plan component');

export type UpdatePraetorPolicyPlanBody = zod.input<typeof UpdatePraetorPolicyPlanBody>;
export type UpdatePraetorPolicyPlanBodyOutput = zod.output<typeof UpdatePraetorPolicyPlanBody>;
